module.exports = __webpack_public_path__ + "static/img/3980_phase_function_Paper_PointsHejduk_Prediction.b15c547.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3980_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Y24a
// module chunks = 0